export default __webpack_public_path__ + "static/Connect-Page-Header-b09bfe4de4e4c0f6c155567e67c53f0e.webp";